'use client'

import { Children, type ReactNode } from 'react'
import { cx } from '../utils/cx'

export function CommentThread({
  label,
  children,
  empty,
  className
}: {
  label?: ReactNode
  children?: ReactNode
  empty?: ReactNode
  className?: string
}) {
  const hasChildren = Children.count(children) > 0
  return (
    <div className={cx('st-comments', className)}>
      {label && <div className="st-c-label">{label}</div>}
      <div className="st-c-thread">{!hasChildren && empty ? <div className="st-c-empty">{empty}</div> : children}</div>
    </div>
  )
}

interface CommentItemProps {
  who?: ReactNode
  when?: ReactNode
  text?: ReactNode
  variant?: 'client' | 'time-stamp'
  stamp?: ReactNode
  onStampClick?: () => void
  className?: string
}

export function CommentItem({ who, when, text, variant, stamp, onStampClick, className }: CommentItemProps) {
  return (
    <div className={cx('st-c-item', variant, className)}>
      <div className="c-top">
        <span className="c-who">{who}</span>
        {when && <span className="c-when">{when}</span>}
      </div>
      <div className="c-txt">
        {stamp && (
          <span className="c-pill" onClick={onStampClick}>
            {stamp}
          </span>
        )}
        {text}
      </div>
    </div>
  )
}

interface CommentInputProps {
  value?: string
  onChange?: (value: string) => void
  onSend?: () => void
  placeholder?: string
  stampLabel?: ReactNode
  onStamp?: () => void
  className?: string
}

export function CommentInput({
  value,
  onChange,
  onSend,
  placeholder = 'Leave a note…',
  stampLabel,
  onStamp,
  className
}: CommentInputProps) {
  return (
    <div className={cx('st-c-input', className)}>
      <div className="box">
        <textarea value={value ?? ''} onChange={(e) => onChange?.(e.target.value)} placeholder={placeholder} />
        <button type="button" className="send" onClick={onSend}>
          Send
        </button>
      </div>
      {stampLabel && (
        <button type="button" className="tsbtn" onClick={onStamp}>
          {stampLabel}
        </button>
      )}
    </div>
  )
}
